<template>
  <div class="nav-page">
    <Navigator class="nav"></Navigator>
    <router-view class="router-main"/>
  </div>
</template>

<script>
  import Navigator from '@/components/Navigator'
  export default {
    name: "NavContainer",
    components: {
      Navigator,
    },
  }
</script>

<style lang="scss" scoped>
  .nav-page {
    height: 100%;
    .nav {
      position: fixed;
      top: 0;
      z-index: 999;
    }
    .router-main {
      padding: 95px 20px 25px;
    }
  }

</style>